import * as React from 'react';

import { InfoCircleOutlined, LoadingOutlined } from '@ant-design/icons';
import { Col, Row, Tooltip, Typography, Spin } from 'antd';

import { ReportDetailState } from '../../hooks/useReportDetail';


type Props = {
    reportDetail: ReportDetailState
    reportDetail2?: ReportDetailState
}

export const TotalTable: React.FC<Props> = ({
    reportDetail,
    reportDetail2,
}) => {
    const data = reportDetail.result;
    const data2 = reportDetail2?.result;

    const WrapperRow = data2 ?
        ({ children }: { children: React.ReactNode }) => {
            return (
                <Row>
                    {children}
                </Row>
            );
        } :
        ({ children }: { children: React.ReactNode  }) => {
            return <>{children}</>;
        };

    const WrapperCol = data2 ?
        ({ children }: { children: React.ReactNode  }) => {
            return (
                <Col span={12}>{children}</Col>
            );
        } :
        ({ children }: { children: React.ReactNode }) => {
            return <>{children}</>;
        };

    return (
        <div>
            <div>
                <Typography.Text style={{ margin: '0.5rem' }}>
                    集計結果
                </Typography.Text>
                <Tooltip
                    title='上のプルダウンで表示対象にしているユーザーでの集計結果を表示しています。'
                >
                    <InfoCircleOutlined />
                </Tooltip>
            </div>

            <WrapperRow>
                <WrapperCol>
                    <table className='test-info-table'>
                        <tbody>
                            <TableRow loading={!data} label='解答者数' value={`${data?.answeredUserCount ?? '-'}名/${data?.targetUserCount ?? '-'}名`} />
                            <TableRow loading={!data} label='解答回数' value={`${data?.resultCount ?? '-'}回`} />
                            <TableRow loading={!data} label='満点' value={`${data?.maxScore ?? '-'}`} />
                            <TableRow loading={!data} label='平均点' value={`${data?.averageScore ?? '-'}`} />
                            <TableRow loading={!data} label='最高点' value={`${data?.highestScore ?? '-'}`} />
                            <TableRow loading={!data} label='最低点' value={`${data?.lowestScore ?? '-'}`} />
                        </tbody>
                    </table>
                </WrapperCol>

                <WrapperCol>
                    {data2 && (
                        <table className='test-info-table'>
                            <tbody>
                                <TableRow loading={!data2} label='解答者数' value={`${data2?.answeredUserCount ?? '-'}名/${data2?.targetUserCount ?? '-'}名`} />
                                <TableRow loading={!data2} label='解答回数' value={`${data2?.resultCount ?? '-'}回`} />
                                <TableRow loading={!data2} label='満点' value={`${data2?.maxScore ?? '-'}`} />
                                <TableRow loading={!data2} label='平均点' value={`${data2?.averageScore ?? '-'}`} />
                                <TableRow loading={!data2} label='最高点' value={`${data2?.highestScore ?? '-'}`} />
                                <TableRow loading={!data2} label='最低点' value={`${data2?.lowestScore ?? '-'}`} />
                            </tbody>
                        </table>
                    )}
                </WrapperCol>
            </WrapperRow>
        </div>
    );
};


type TableRosProps = {
    label: string
    value?: string
    loading?: boolean
}

const TableRow: React.FC<TableRosProps> = ({
    label,
    value,
    loading,
}) => {
    return value === undefined ?
        (
            <tr>
                <th colSpan={2}>{label}</th>
            </tr>
        ) :
        (
            <tr>
                <th>{label}</th>
                <td>{loading ? <Spin indicator={<LoadingOutlined spin />} size="small" /> : value}</td>
            </tr>
        );
};